import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";

import App from "./App";
import { queryClient } from "./lib/query";
import "./index.css";

// ── Stale-chunk recovery ──────────────────────────────────────────────
// After a new deploy, Vite's hashed chunk filenames change and the old
// chunks are removed from the server. A browser tab still running the
// previous build will 404 when it lazy-loads a route (e.g. Payment
// Gateway). Catch that failure and reload once to pick up the fresh
// build. The timestamp guard prevents a reload loop if a chunk is
// genuinely missing.
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  const last = Number(sessionStorage.getItem("chunkReloadAt") || 0);
  if (Date.now() - last < 10_000) return;
  sessionStorage.setItem("chunkReloadAt", String(Date.now()));
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
